var _rect, _rect2, _circle, _path, _path2, _path3, _circle2, _circle3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReneeAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 48,
    fill: "#1F2937"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 448,
    height: 448,
    rx: 40,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 214,
    r: 108,
    fill: "#F4C7A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146 188C146 112 198 76 258 76C326 76 372 122 372 190V230H146V188Z",
    fill: "#5B2147"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168 396C184 326 220 296 256 296C292 296 328 326 344 396V428H168V396Z",
    fill: "#B83280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M208 222C220 236 236 244 256 244C276 244 292 236 304 222",
    stroke: "#7C2D12",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 204,
    r: 10,
    fill: "#1F2937"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 204,
    r: 10,
    fill: "#1F2937"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206 170C218 162 230 160 242 164",
    stroke: "#4C1D95",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M270 164C282 160 294 162 306 170",
    stroke: "#4C1D95",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M180 128C212 98 302 88 350 148",
    stroke: "#F472B6",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 80,
    y1: 64,
    x2: 432,
    y2: 448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C1D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#BE185D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59E0B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReneeAvatar);
export default __webpack_public_path__ + "static/media/renee-avatar.b7075f6a06eb2e6218749c90a82d4b9f.svg";
export { ForwardRef as ReactComponent };